export default {
  path: '/order',
  name: 'order',
  component: () => import('../../views/Layout/index'),
  meta: {
    title: '订单',
    // keepAlive: false
  },
  children: [
    {
      // 订单-号卡订单-互联网购卡订单
      path: 'numCardOrder/internetBuyCardOrder',
      name: 'internetBuyCardOrder',
      component: () => import('../../views/Order/NumCardOrder/InternetBuyCardOrder/InternetBuyCardOrderIndex'),
      meta: { title: '互联网购卡', keepAlive: false }
    },
    {
      // 订单-号卡订单-互联网购卡订单-订单详情
      path: 'numCardOrder/internetBuyCardOrderDetail',
      // path: 'numCardOrder/internetBuyCardOrder/orderDetail',
      name: 'internetBuyCardOrderDetail',
      // hidden: true,
      component: () => import('../../views/Order/NumCardOrder/InternetBuyCardOrder/OrderDetail/InternetBuyCardOrderDetail'),
      meta: { title: '互联网购卡订单详情', keepAlive: false }
    },
    {
      // 订单-号卡订单-现场购卡
      path: 'numCardOrder/sceneBuyCardOrder',
      name: 'sceneBuyCardOrder',
      component: () => import('../../views/Order/NumCardOrder/SceneBuyCardOrder/SceneBuyCardOrderIndex'),
      meta: { title: '现场购卡', keepAlive: false }
    },
    {
      // 订单-号卡订单-现场购卡-订单详情
      path: 'numCardOrder/sceneBuyCardOrderDetail',
      name: 'sceneBuyCardOrderDetail',
      // hidden: true,
      component: () => import('../../views/Order/NumCardOrder/SceneBuyCardOrder/OrderDetail/SceneBuyCardOrderDetail'),
      meta: { title: '现场购卡订单详情', keepAlive: false }
    },
    {
      // 订单-充值/缴费订单
      path: 'rechargeAndPaymentOrder',
      name: 'rechargeAndPaymentOrder',
      component: () => import('../../views/Order/RechargeAndPaymentOrder/RechargeAndPaymentOrderIndex'),
      meta: { title: '充值/缴费订单', keepAlive: false }
    },
    {
      // 订单-充值/缴费订单-订单详情
      path: 'rechargeAndPaymentOrderDetail',
      name: 'rechargeAndPaymentOrderDetail',
      // hidden: true,
      component: () => import('../../views/Order/RechargeAndPaymentOrder/OrderDetail/RechargeAndPaymentOrderDetail'),
      meta: { title: '充值/缴费订单详情', keepAlive: false }
    },
    {
      // 套餐管理
      path: 'packageManage',
      name: 'packageManage',
      component: () => import('../../views/Order/PackageManage/PackageManage'),
      meta: { title: '套餐管理', keepAlive: false }
    },
  ]
}